import { IconButton, Tooltip, CircularProgress } from '@mui/material';
import { Refresh as RefreshIcon } from '@mui/icons-material';

interface RefetchButtonProps {
    /** Function to call when refresh is clicked */
    onRefetch: () => void;
    /** Whether any query is currently fetching */
    isRefetching: boolean;
    /** Optional tooltip text, defaults to "Refresh" */
    tooltipText?: string;
}

/**
 * A refresh button component that shows a loading spinner when data is being refetched.
 * Used in admin pages to trigger Redux query refetches.
 */
export const RefetchButton = ({
    onRefetch,
    isRefetching,
    tooltipText = 'Refresh',
}: RefetchButtonProps) => {
    return (
        <Tooltip title={tooltipText}>
            <IconButton
                color="primary"
                onClick={onRefetch}
                disabled={isRefetching}
                sx={{
                    border: '1px solid',
                    borderColor: 'divider',
                }}
            >
                {isRefetching ? <CircularProgress size={24} /> : <RefreshIcon />}
            </IconButton>
        </Tooltip>
    );
};
